import React from 'react';
import './index.css';

const PrivacyPolicyPage = () => {
    return (
        <div className="policy-page-container">
            <h1>🔐 PRIVACY POLICY — NOTTSIFY</h1>

            <h2>Data We Collect</h2>
            <ul>
                <li>Name</li>
                <li>Email</li>
                <li>Login credentials</li>
                <li>Uploaded documents</li>
                <li>Usage analytics</li>
            </ul>

            <h2>How We Use Data</h2>
            <ul>
                <li>Provide study notes generation</li>
                <li>Improve AI services</li>
                <li>Customer support</li>
                <li>Fraud prevention</li>
            </ul>

            <h2>Third Party Sharing</h2>
            <p>We may share data with:</p>
            <ul>
                <li>AI API providers (for processing notes)</li>
                <li>Razorpay (for payment processing)</li>
                <li>Hosting providers</li>
            </ul>
            <p>We do NOT sell personal data.</p>

            <h2>Data Security</h2>
            <p>We implement:</p>
            <ul>
                <li>Encryption</li>
                <li>Secure authentication</li>
                <li>Access controls</li>
            </ul>

            <h2>User Rights</h2>
            <p>Users can:</p>
            <ul>
                <li>Request data deletion</li>
                <li>Delete account</li>
                <li>Contact support for data requests</li>
            </ul>
        </div>
    );
};

export default PrivacyPolicyPage;
